var heading_default = {
  "fontElementMap": "p9y-D",
  "elementSpacing": "VTRRk",
  "headerOne": "qdCq- VTRRk",
  "headerTwo": "ZV2Il VTRRk",
  "headerThree": "pKcrF VTRRk",
  "headerFour": "_8TEWr VTRRk",
  "headerFive": "W7c31 VTRRk",
  "headerSix": "_8hIu4 VTRRk",
  "child": "ik3-v"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
